import angular from 'angular'

import { financial } from 'redevConfig'

const list = (financial && financial.list) || ''
const listPage = list ? require(`redevelopment/input/financial/${list.templateName}`) : require('./view/list.html')
const financialListCtrl = list ? require(`redevelopment/input/financial/${list.controllerName}`) : require('./financialListCtrl.js')
export default angular
    .module('input.financialCounting.financial', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.financialCounting.financial', {
            url: '/financial',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'input.financialCounting.financial.list',
            title: '财务数据采集',
        })
        $stateProvider.state('input.financialCounting.financial.list', {
            url: '/list',
            template: listPage,
            controller: 'financialListCtrl',
        })
    }])
    .controller('financialListCtrl', financialListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/financial/index.js